import React from 'react';
import { Helmet } from 'react-helmet-async';
import SITE from '../site';

//dati strutturati (JSON-LD). WebSite è il segnale principale con cui Google sceglie il nome del sito nei risultati
const WEBSITE_DATA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": SITE.name,
  "alternateName": SITE.alternateName,
  "url": SITE.url
};

const APP_DATA = {
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": SITE.name,
  "description": SITE.description,
  "url": SITE.url,
  "author": {
    "@type": "Person",
    "name": SITE.author
  },
  "applicationCategory": "GameApplication",
  "operatingSystem": "Web Browser",
  "inLanguage": "it-IT",
  "isAccessibleForFree": true,
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "EUR"
  }
};

const SEOHead = ({
  title = SITE.title,
  description = SITE.description,
  url = SITE.url,
  image = SITE.url + SITE.image,
  type = "website"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={SITE.author} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content={String(SITE.imageWidth)} />
      <meta property="og:image:height" content={String(SITE.imageHeight)} />
      <meta property="og:image:alt" content={SITE.imageAlt} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content="it_IT" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={SITE.imageAlt} />

      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      <script type="application/ld+json">{JSON.stringify(WEBSITE_DATA)}</script>
      <script type="application/ld+json">{JSON.stringify(APP_DATA)}</script>
    </Helmet>
  );
};

export default SEOHead;
